import { alpha, useTheme } from '@mui/material/styles'
import { useChat } from '../context/useChat'

const getInitials = (name?: string | null) => {
  const safeName = name?.trim() || '?'
  return safeName
    .split(' ')
    .map(part => part.charAt(0))
    .join('')
    .toUpperCase()
}

export const TypingIndicator = () => {
  const theme = useTheme()
  const { participantAvatarUrl, participantDisplayName } = useChat()

  return (
    <div className="flex items-end gap-3 animate-in fade-in slide-in-from-bottom-2 duration-300">
      {participantAvatarUrl ? (
        <img
          src={participantAvatarUrl}
          alt={participantDisplayName ?? ''}
          className="h-8 w-8 flex-shrink-0 rounded-full object-cover shadow-sm"
        />
      ) : (
        <div
          className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full text-[10px] font-semibold shadow-sm"
          style={{
            backgroundColor: alpha(theme.palette.primary.main, 0.12),
            color: theme.palette.primary.main,
          }}
        >
          {getInitials(participantDisplayName)}
        </div>
      )}

      <div
        className="flex items-center gap-[5px] rounded-2xl rounded-bl-md px-4 py-3"
        style={{
          backgroundColor: alpha(theme.palette.text.primary, 0.08),
        }}
      >
        <span className="typing-dot h-[7px] w-[7px] rounded-full bg-slate-400" style={{ animationDelay: '0ms' }} />
        <span className="typing-dot h-[7px] w-[7px] rounded-full bg-slate-400" style={{ animationDelay: '160ms' }} />
        <span className="typing-dot h-[7px] w-[7px] rounded-full bg-slate-400" style={{ animationDelay: '320ms' }} />
      </div>
    </div>
  )
}
